import { atom } from "jotai";

// UI state
export const mobileMenuOpenAtom = atom(false);
export const searchOpenAtom = atom(false);

// Business listing state - stores business items with their map indices
export const businessItemsAtom = atom<Array<{ id: string; index: number }>>([]);
